import React, { memo } from 'react';
import { Link } from 'react-router-dom'

const Breadcrumbs = ({ breadCrumbsList, dict }) => {
    if (!breadCrumbsList || breadCrumbsList.length < 1) return null
    return (

        <div className="breadcrumbs">
            <ul className="breadcrumbs__list">
                {breadCrumbsList.map((page, index) =>
                    <li key={"page.name" + index} className="breadcrumbs__list__item">
                        {page.link ?
                            <Link
                                to={`${page.link}`}
                                className={`breadcrumbs__list__link`}
                            >
                                {dict[`breadcrumbs.${page.name}`] || page.name}
                            </Link>
                            : dict[`breadcrumbs.${page.name}`] || page.name}
                    </li>)}
            </ul>
        </div>
    )
}

export default memo(Breadcrumbs);
